import styled from "styled-components";

export const TabPanelRoot = styled.div`
    width: 100%;
    height: 100%;
`;
